import { createSlice } from '@reduxjs/toolkit'
import { fetchAllUsersThunk, fetchUserProfileByToken } from './userThunk'
interface UserProfileType {
  email: string
  name: string
  userId: string
}

interface UserState {
  allUsers: UserProfileType[] | null // Array of all user profiles
  singleUser: UserProfileType | null // Data for a single user profile
  isLoading: boolean
  error: any
}

const initialState: UserState = {
  allUsers: null,
  singleUser: null,
  isLoading: false,
  error: null,
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    clearUserProfile: (state) => {
      state.singleUser = null
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllUsersThunk.pending, (state) => {
        state.isLoading = true
      })
      .addCase(fetchAllUsersThunk.fulfilled, (state, action) => {
        state.allUsers = action.payload
        state.isLoading = false
      })
      .addCase(fetchAllUsersThunk.rejected, (state, action) => {
        state.error = action.payload || 'Failed to fetch user profiles'
        state.isLoading = false
      })
  },
})

export const { clearUserProfile } = userSlice.actions

export default userSlice.reducer
